import type { IFloatingPosition } from './IFloatingPosition';

const MARGIN = 8;

/**
 * Розміщення плаваючого списку під полем (прототип pickerVM): якщо внизу не вміщується, а вгорі є місце — відкривається вгору;
 * ліворуч притискається до вікна з відступом 8px; мінімальна ширина — ширина поля (matchWidth) або задана.
 */
export function floatingPlacement(
  anchor: { top: number; bottom: number; left: number; width: number },
  panel: { width: number; height: number },
  viewport: { width: number; height: number },
  gap = 4,
  minWidth = 0,
  matchWidth = true,
): IFloatingPosition {
  const width = matchWidth ? Math.max(minWidth, anchor.width) : minWidth;
  const up = anchor.bottom + gap + panel.height > viewport.height - MARGIN && anchor.top - gap - panel.height >= MARGIN;
  const left = Math.max(MARGIN, Math.min(anchor.left, viewport.width - Math.max(panel.width, width) - MARGIN));
  return up ? { left, bottom: viewport.height - anchor.top + gap, minWidth: width } : { left, top: anchor.bottom + gap, minWidth: width };
}
